import { render, staticRenderFns } from "./ExcelImportBtn.vue?vue&type=template&id=b2f60a5c&scoped=true&"
import script from "./ExcelImportBtn.vue?vue&type=script&lang=js&"
export * from "./ExcelImportBtn.vue?vue&type=script&lang=js&"
import style0 from "./ExcelImportBtn.vue?vue&type=style&index=0&id=b2f60a5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f60a5c",
  null
  
)

export default component.exports